import { z } from 'zod';
import { AuditLogIdSchema, CaseIdSchema, IsoTimestampSchema, UserIdSchema } from './common.js';

/**
 * Vanlige handlinger i revisjonsloggen.
 * Listen utvides etter behov – bruk string for ukjente handlinger.
 */
export const AuditActionSchema = z.enum([
  'user.login',
  'user.logout',
  'user.created',
  'user.disabled',
  'case.created',
  'case.updated',
  'case.archived',
  'case.closed',
  'case.member_added',
  'case.member_removed',
  'source.created',
  'source.deleted',
  'import.started',
  'import.completed',
  'import.failed',
  'document.viewed',
  'document.exported',
  'event.viewed',
  'timeline.exported',
  'invitation.sent',
  'invitation.accepted',
  'invitation.revoked',
  'file.stored',
  'case.deleted',
  'access.changed',
  'data.exported',
]);
export type AuditAction = z.infer<typeof AuditActionSchema>;

/**
 * Revisjonsloggoppføring – append-only.
 * Ingen oppføring skal noensinne endres eller slettes etter at den er skrevet.
 * Integritet sikres av databasen (no UPDATE/DELETE-rettigheter på tabellen).
 */
export const AuditLogEntrySchema = z.object({
  id: AuditLogIdSchema,
  /** Satt dersom handlingen tilhører en konkret sak */
  caseId: CaseIdSchema.optional(),
  actorUserId: UserIdSchema,
  action: AuditActionSchema,
  /** Type objekt handlingen gjelder (f.eks. "document", "event") */
  targetType: z.string().optional(),
  /** Id på objektet handlingen gjelder */
  targetId: z.string().optional(),
  timestamp: IsoTimestampSchema,
  /** Tilleggsdata, f.eks. IP-adresse, nettleser, endrede felter */
  metadata: z.record(z.string(), z.unknown()).optional(),
});

export type AuditLogEntry = z.infer<typeof AuditLogEntrySchema>;
